import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactForm } from '../components/ContactForm';

export const ContactPage = () => {
  return (
    <>
      <Helmet>
        <title>Contact Heritage Home Health LLC | Get In Touch</title>
        <meta
          name="description"
          content="Contact Heritage Home Health LLC for a free consultation about in-home care services. Call us at +1 (608) 358-9578 or fill out our contact form."
        />
      </Helmet>
      <div className="min-h-screen bg-warm-beige" data-testid="contact-page">
        <Navigation />
        <main>
          {/* Hero Section */}
          <section className="relative pt-24 pb-10 sm:pt-28 md:pt-40 sm:pb-12 md:pb-16 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-b from-soft-gold/10 via-transparent to-transparent" />
            <div className="absolute top-16 right-0 w-72 h-72 sm:w-[420px] sm:h-[420px] md:w-[500px] md:h-[500px] bg-gradient-to-bl from-soft-gold/15 to-transparent rounded-full blur-3xl" />
            
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 md:px-12 text-center">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-soft-gold mb-4">
                  Get In Touch
                </span>
                <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight text-navy mb-5 sm:mb-6">
                  Contact{' '}
                  <span className="text-gradient-gold">Heritage Home Health LLC</span>
                </h1>
                <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                  Ready to explore care options for your loved one? We're here to answer your 
                  questions and help you take the first step towards exceptional in-home care.
                </p>
              </motion.div>
            </div>
          </section>

          <ContactForm />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default ContactPage;
